/**
 * PayPalButton - Bouton de paiement PayPal
 * Design System v2 - Style Landing (page publique)
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2, ExternalLink } from 'lucide-react';

interface PayPalButtonProps {
  isLoading: boolean;
  disabled: boolean;
  onClick: () => void;
  amount: number;
  currency: string;
}

export const PayPalButton: React.FC<PayPalButtonProps> = ({
  isLoading,
  disabled,
  onClick,
  amount,
  currency,
}) => {
  const { t } = useTranslation();
  const formatAmount = (amount: number, currency: string) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: currency || 'EUR',
    }).format(amount);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || isLoading}
      className="w-full py-4 bg-[#0070ba] hover:bg-[#003087] text-white font-bold rounded-xl
        disabled:opacity-50 disabled:cursor-not-allowed
        transition-all duration-300 flex items-center justify-center gap-3
        hover:shadow-lg hover:-translate-y-0.5"
    >
      {isLoading ? (
        <>
          <Loader2 className="w-5 h-5 animate-spin" />
          {t('publicPayment.paypal.redirecting')}
        </>
      ) : (
        <>
          {/* PayPal Logo */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className="w-6 h-6 fill-current"
          >
            <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106zm14.146-14.42a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.254-.93 4.778-4.005 7.201-9.138 7.201h-2.19a.563.563 0 0 0-.556.479l-1.187 7.527h-.506l-.24 1.516a.56.56 0 0 0 .554.647h3.882c.46 0 .85-.334.922-.788.06-.26.76-4.852.816-5.09a.932.932 0 0 1 .923-.788h.58c3.76 0 6.705-1.528 7.565-5.946.36-1.847.174-3.388-.777-4.471z" />
          </svg>
          <span>{t('publicPayment.paypal.payWith')}</span>
          <span className="text-white/80">({formatAmount(amount, currency)})</span>
          <ExternalLink className="w-4 h-4 ml-1" />
        </>
      )}
    </button>
  );
};

export default PayPalButton;
